import { render, staticRenderFns } from "./akademikpersoneller.vue?vue&type=template&id=9415877c&"
import script from "./akademikpersoneller.vue?vue&type=script&lang=js&"
export * from "./akademikpersoneller.vue?vue&type=script&lang=js&"
import style0 from "./akademikpersoneller.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports